/* eslint-disable no-param-reassign */
import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {useSelector} from 'react-redux'
import {http} from 'hiya-common/src/utils/axios'

export enum OPENENUM {
  close = 0,
  open = 1,
}

// 回归礼包奖励  http://wiki.xunlei.cn/pages/viewpage.action?pageId=178749591
export const get_svip_bet_mission_reward = createAsyncThunk(
  '/live/vip/get_svip_bet_mission_reward',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/vip/get_svip_bet_mission_reward',
      {
        ...p,
        ...store.getState().env.deviceinfo,
      },
      {
        store,
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

// 主接口 http://wiki.xunlei.cn/pages/viewpage.action?pageId=174063399
export const svip_bet_mission_homepage = createAsyncThunk(
  '/live/vip/svip_bet_mission_homepage',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/vip/svip_bet_mission_homepage',
      {
        ...p,
        ...store.getState().env.deviceinfo,
      },
      {
        store,
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

// 任务开启 http://wiki.xunlei.cn/pages/viewpage.action?pageId=174063417
export const start_svip_bet_mission = createAsyncThunk('/live/vip/start_svip_bet_mission', async (p, store: any) => {
  const resp = await http.post(
    '/live/vip/start_svip_bet_mission',
    {
      ...store.getState().env.deviceinfo,
    },
    {
      store,
      xcErrorToast: true,
    }
  )
  return resp.data.data
})

const initialState: {
  // 主接口数据
  info: {
    countdown?: number
    status?: OPENENUM // 0:未开启 1:已开启
    level?: number // 当前等级
    target_level?: number // 目标等级
    reward_image?: string // 奖励图片
    reward_day?: number // 奖励天数
    required_exp?: number // 所需经验
    actual_exp?: number // 原本经验
    current_exp?: number // 当前经验
    selection_rate?: string // 任务顶部文案
    reward_exp?: number // 奖励经验
    buff_info?: {
      status: number // 0:未获得 1已获得
      buff: number // 获得buff倍数
    }
    pendant_image?: string // 挂件图片
    task_level?: number // 玩家属性（1、回归玩家、2、常规玩家）
  }
} = {
  info: {
    countdown: 10000,
    status: OPENENUM.close,
    level: 1,
    target_level: 10,
    reward_image: '1121',
    reward_exp: 100,
    required_exp: 200,
    actual_exp: 500,
    current_exp: 100,
    selection_rate: '',
    buff_info: {status: 1, buff: 1},
    pendant_image: '1121',
  },
}

export const SVIPUpdateSystemSlice = createSlice({
  name: 'SVIPUpdateSystem',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(svip_bet_mission_homepage.fulfilled, (state, action) => {
      Object.assign(state.info, action.payload)
    })
  },
})

export const SVIPUpdateAction = SVIPUpdateSystemSlice.actions
export const useSVIPUpdateState = () => {
  const data = useSelector((state) => state.Animal_Hamster)
  return data
}
export default SVIPUpdateSystemSlice.reducer
